import { Component, Input, OnInit } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../shared/formly/ga-formly.service';
import { UntypedFormGroup } from '@angular/forms';
import { UPLOAD_CONFIG } from './upload-config';

@Component({
  selector: 'uploads-step-one',
  template: `
    <h2 translate>{{sectionTitle}}</h2>

    <div class="row">
      <div class="col-sm-12">
        <div class="form-horizontal col-space-top">
          <formly [form]="form" [fields]="fields" [model]="model"></formly>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <upload-example-template [code]="code"></upload-example-template>
    </div>
  `
})
export class UploadStepOneComponent implements OnInit {
  @Input() public code:string;

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:any;
  public sectionTitle:string;

  constructor(
    private formlyService:GaFormlyService
  ) {
    /**/
  }

  public ngOnInit():void {
    // create component of step one
    this.fields = this.createFields();
    this.sectionTitle = UPLOAD_CONFIG[ this.code ]?.sectionTitle;
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aCustom()
        .withComponent(UPLOAD_CONFIG[ this.code ]?.component)
        .withoutWrapper()
        .withWrapperClass('col-auto')
        .build()
    ];
  }
}
